import {httpRequest} from "../../../utils/HttpRequest";
import {IHistoryParams,IHistoryDetail,ICatalogSearch} from "./dataHistoryTypes"
import {IPage,IPageRet, ISearchPage} from "../../../types/FmsTypes";

class HistoryService {
    async page(params:ICatalogSearch){
        const apiUrl = "/mdm/history/page"
        return await httpRequest.post<IPage<IHistoryDetail>>(apiUrl,params)
    }
}
const historyService = new HistoryService()
export {
    historyService
}